// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['colaborador_satya']


const breadCrumb = [
  { label: "Home", to: "Home" },
  { label: "Situação do País", to: "CountrySituationList" },
];

export default [
  {
    path: "/situacao-pais",
    name: "CountrySituationList",
    component: () => import('@/views/SituacaoPais/SituacaoPaisListPage.vue'),
    meta: {
      roles: ROLES,
      title: "Situação do País",
      breadcrumb: breadCrumb,
    },
  },
  {
    path: "/situacao-pais/novo",
    name: "CountrySituationNew",
    component: () => import('@/views/SituacaoPais/NovaSituacaoPaisPage.vue'),
    meta: {
      roles: ROLES,
      title: "Nova Situação",
      breadcrumb: [
        ...breadCrumb,
        { label: "Nova Situação", to: "CountrySituationNew" },
      ],
    },
  },
  {
    path: "/situacao-pais/:id/edit",
    name: "CountrySituationEdit",
    component: () => import('@/views/SituacaoPais/NovaSituacaoPaisPage.vue'),
    meta: {
      roles: ROLES,
      title: "Detalhes da Situação",
      breadcrumb: [
        ...breadCrumb,
        { label: "Detalhes", to: "CountrySituationEdit" },
      ],
    },
  },
];
